var Usersession = (function(){
var user_code ="";
var prop_code ="1";
var user_cityid ="";
var postexpdays ="0";
var chatcode = {chatid:0,code:'',ctype:''}
var srchcopts = {contryid:"1",ctid:"1",localid:"1",trnstpid:"1",protype:"1",postedby:"1"};
var subusers = [
			{mid:2,mpid:1,mupoints:10,mofferid:0,muname:"bijil",mudob:"",mutypeid:0,isf:"1"}
			
			];
var prop_ptype = "";
var user_ptypeid = "7";

var guest_mailid = "";
var villaid = 0;
var msgallowid = 0;

var villaname = "my villa";
var useraname = "";

var villatypeid = "1";

var colorcode = "#ffff";
var rvcmsguid = 0;
var ismsgtype = false;
var ispvtvsrch = false;
var rvcactuid = 0;

var userpfp = {pfpid:3,age:20,utf:true,uname:'userguest',points:10,utpid:0,dob:"",msgalow:0}
var user_id =0;
var allowmsgid =0;

var user_pin ='1234';
var pblcvls =[{uid:0,villaid:"10",villaname:"Learning",vt:1,ucnt:0}]; 
var subuserstatus = 0;

var villachats = [
		 {uid:2,msg:'',pfpid:0,utid:0,uname:'bijil',code:'#ffff',utype:true,vid:1}
				
		];
var umsg = '';
var villasts =0;
var villauserpfps = [
		 {uid:2,pfpid:2,utf:true,uname:'bijil',x:'200px',y:'100px'}

		];
var addrevmvillauser = {add:0,remove:0};
var isusergift = 0;

var getIsgifted = function(){
return isusergift;
};
var setIsgifted = function(code: any)
{
isusergift = code;
};

var getVilladdremv = function(){
return addrevmvillauser;
};
var setVilladdremv = function(code: any){
addrevmvillauser = code;
};


var getVillapfps = function(){
return villauserpfps;
};
var setVillapfps = function(code: any){
villauserpfps = code;
};

var getVillasts = function(){
return villasts;
};
var setVillasts = function(code: any){
villasts = code;
};

var getVumsg = function(){
return umsg;
};
var setVumsg = function(code: any){
umsg = code;
};

var getVillachat = function(){
return villachats;
};
var setVillachat = function(code: any){
villachats = code;
};

var getSubuserstatus = function(){
return subuserstatus;
};
var setSubuserstatus = function(code: any){
subuserstatus = code;
};


var getAlllowmsgId = function(){
return allowmsgid;
};
var setAlllowmsgId = function(code: any){
allowmsgid = code;
};


var getUserpfp = function(){
return userpfp;
};
var setUserpfp = function(code: any){
userpfp = code;
};
var getEmojchat = function(){
return ismsgtype;
};
var setEmojchat = function(code: any){
ismsgtype = code;
};

var getRcvmsguserid = function(){
return rvcmsguid;
};
var setRcvmsguserid = function(code: any){
rvcmsguid = code;
};

var getsubusers = function(){
return subusers;
};
var setsubusers = function(code: any){
subusers = code;
};

var getChatcode = function(){
return chatcode;
};
var setChatcode = function(code: any){
chatcode = code;
};

var getPostexpdays = function(){
return postexpdays;
};
var setPostexpdays = function(code: any){
postexpdays = code;
};

var getGuestmailid = function(){
return guest_mailid;
};
var setGuestmailid = function(code: any){
guest_mailid = code;
};


var getUsertypeid = function(){
return user_ptypeid;
};
var setUsertypeid = function(code: any){
user_ptypeid = code;
};


var getProcode = function(){
return prop_code;
};
var setProcode = function(code: any){
prop_code = code;
};
var getType = function(){
return prop_ptype;
};
var setType = function(code: any){
prop_ptype = code;
};

var getCode = function(){
return user_code;
};
var setCode = function(code: any){
user_code = code;
};
var getCityId = function(){
return user_cityid;
};
var setCityId = function(uctid: any){
user_cityid = uctid;
};
var getSearchopts = function(){
return srchcopts;
};
var setSearchopts = function(opts: any){
srchcopts = opts;
};
var getVillaId = function(){
return villaid;
};
var setVillaId = function(opts: any){
villaid = opts;
};

var getVillaname = function(){
return villaname;
};
var setVillaname = function(code: any){
villaname = code;
};
var getColorcode = function(){
return colorcode;
};
var setColorcode = function(code: any){
colorcode = code;
};
var getUserId = function(){
return user_id;
};
var setUserId = function(code: any){
user_id = code;
};
var getPvtvlsrch = function(){
return ispvtvsrch;
};
var setPvtvlsrch = function(code: any){
ispvtvsrch = code;
};
var getVillatype = function(){
return villatypeid;
};
var setVillatype = function(code: any){
villatypeid = code;
};
var getRecvactid = function(){
return rvcactuid;
};
var setRecvactid = function(code: any){
rvcactuid = code;
};
var getUserpin = function(){
return user_pin;
};
var setUserpin = function(code: any){
user_pin = code;
};
var setPubvillas = function(code: any){
pblcvls = code;
};
var getPubvillas = function(){
return pblcvls;
};
var setUsername = function(code: any){
useraname = code;
};
var getUsername = function(){
return useraname;
};
var setMsgallow = function(code: any){
msgallowid = code;
};
var getMsgallow = function(){
return msgallowid;
};

return{
getCode: getCode,
setCode: setCode,
getCityId: getCityId,
setCityId: setCityId,
getSearchopts: getSearchopts,
setSearchopts:setSearchopts,
getType:getType,
setType:setType,
getProcode:getProcode,
setProcode:setProcode,
getUsertypeid:getUsertypeid,
setUsertypeid:setUsertypeid,
getGuestmailid:getGuestmailid,
setGuestmailid:setGuestmailid,
getPostexpdays:getPostexpdays,
setPostexpdays:setPostexpdays,
getChatcode:getChatcode,
setChatcode:setChatcode,
getVillaId:getVillaId,
setVillaId:setVillaId,
getVillaname:getVillaname,
setVillaname:setVillaname,
getUserpfp:getUserpfp,
setUserpfp:setUserpfp,
getColorcode:getColorcode,
setColorcode:setColorcode,
getUserId:getUserId,
setUserId:setUserId,
getsubusers:getsubusers,
setsubusers:setsubusers,
getRcvmsguserid:getRcvmsguserid,
setRcvmsguserid:setRcvmsguserid,
getEmojchat:getEmojchat,
setEmojchat:setEmojchat,
getPvtvlsrch:getPvtvlsrch,
setPvtvlsrch:setPvtvlsrch,
getVillatype:getVillatype,
setVillatype:setVillatype,
getRecvactid:getRecvactid,
setRecvactid:setRecvactid,
getUserpin:getUserpin,
setUserpin:setUserpin,
getPubvillas:getPubvillas,
setPubvillas:setPubvillas,
setUsername:setUsername,
getUsername:getUsername,
setMsgallow:setMsgallow,
getMsgallow:getMsgallow,
getAlllowmsgId:getAlllowmsgId,
setAlllowmsgId:setAlllowmsgId,
getSubuserstatus:getSubuserstatus,
setSubuserstatus:setSubuserstatus,
getVillachat:getVillachat,
setVillachat:setVillachat,
getVumsg:getVumsg,
setVumsg:setVumsg,
getVillasts:getVillasts,
setVillasts:setVillasts,
getVillapfps:getVillapfps,
setVillapfps:setVillapfps,
getVilladdremv:getVilladdremv,
setVilladdremv:setVilladdremv,
getIsgifted:getIsgifted,
setIsgifted:setIsgifted
}
})();
export default Usersession;